// 繁體中文翻譯
export const zhTW = {
  title: 'HandinCap',
  subtitle: '讓每一桿都算數',
  create: '建立新局',
  courseTitle: '球場設定',
  autoMode: '自動搜尋',
  manualMode: '手動輸入',
  searchPlaceholder: '搜尋球場名稱...',
  selectCourse: '選擇球場',
  gameType: '比賽類型',
  setPar: '設定各洞PAR值',
  confirmCourse: '確認設定',
  playerTitle: '玩家設定',
  players: '玩家',
  player1: '玩家1',
  player2: '玩家2',
  player3: '玩家3',
  player4: '玩家4',
  player5: '玩家5',
  player6: '玩家6',
  player7: '玩家7',
  player8: '玩家8',
  enterName: '輸入姓名',
  gameMode: '遊戲模式',
  matchPlay: 'Match Play',
  win123: 'Win123',
  skins: 'Skins',
  baccarat: '百家樂',
  stake: '底注',
  prizePool: '獎金池',
  penaltyPot: '罰金池',
  optional: '可選',
  enterStake: '輸入金額（可選）',
  handicap: '差點',
  handicapSettings: '差點設定',
  off: '關',
  on: '開',
  back: '返回',
  start: '開始比賽',
  hole: '洞',
  par: 'PAR',
  nextHole: '確認成績',
  currentMoney: '即時戰況',
  poolBalance: '獎池餘額',
  holeTied: '本洞平手',
  poolGrows: '下洞獎池',
  skinsWinner: '{player}贏得Skins！',
  holeSettlement: '本洞結算',
  netScore: '淨桿',
  rank: '第{n}名',
  winner: '勝利',
  resume: '繼續比賽',
  finishRound: '確認並結束',
  kaki: '球友',
  kakiDeleteConfirm: '確定刪除這組球友嗎?',
  confirmHoleScore: '確認第{hole}洞成績',
  holeScoresSummary: '各玩家成績：',
  cancel: '取消',
  yes: '確定',
  confirm: '確認',
  switchLang: '語言',
  noStake: '請輸入底注金額',
  atLeast2: '請至少輸入2名玩家',
  gameOver: '比賽結束！',
  backToHome: '回到首頁',
  out: '前九',
  in: '後九',
  total: '計',
  totalScore: '總成績',
  standardPar: '標準桿',
  finalSettlement: '最終結算',
  noScoreData: '還沒有開始記分',
  f9: '前9洞',
  b9: '後9洞',
  f18: '前18洞',
  b18: '後18洞',
  f9Desc: '1-9洞',
  b9Desc: '10-18洞',
  f18Desc: '1-18洞標準',
  b18Desc: '10-18,1-9洞',
  duplicateNames: '玩家名不可重複',
  screenshotHint: '建議您先截圖保存成績記錄',
  totalLoss: '累計',
  totalPar: 'PAR',
  noCourses: '未找到球場',
  trySearch: '請嘗試其他關鍵字',
  front9: '前九',
  back9: '後九',
  eagle: '老鷹',
  birdie: '小鳥',
  parLabel: '標準桿',
  bogey: '柏忌',
  doubleplus: '雙柏忌+',
  selectHoleToEdit: '選擇要修改的洞',
  holeJumpTitle: '跳到第幾洞',
  holeJumpReturnToast: '還有 {n} 個洞沒打，回到第 {hole} 洞',
  editHole: '修改',
  save: '儲存',
  scoreUpdated: '成績已更新，金額已重算',
  matchPlayDesc: '每洞最低淨桿者贏，輸家付底注',
  win123Desc: '按名次罰款入池，可喊UP賭大',
  skinsDesc: '每洞投注，唯一低桿者通吃',
  baccaratDesc: '兩兩對戰，UP加倍賭注',
  reportTitle: '的比賽報告',
  scoreDistribution: '成績分佈',
  puttingAnalysis: '推桿分析',
  totalPutts: '總推桿',
  avgPerHole: '平均/洞',
  onePutt: '一推進洞',
  threePutts: '三推及以上',
  holes: '洞',
  penaltyStats: '罰桿統計',
  waterHazard: '水障礙',
  stats: '統計',
  attempts: '嘗試',
  times: '次',
  holeByHole: '逐洞成績',
  viewFullDetail: '查看完整明細',
  fullDetail: '完整明細',
  strokes: '桿',
  putt: '推',
  water: '水障',
  clickNameToView: '點擊名字查看詳情',
  confirmPutts: '確認推桿數',
  zeroPuttsWarning: '以下玩家推桿數為 0：',
  puttsScore: '成績',
  puttsStrokes: '桿',
  puttsPutts: '推桿',
  puttsTip: '提示：除非是切桿進洞(chip-in)，否則推桿數通常不為 0',
  puttsGoBack: '返回修改',
  puttsConfirm: '確認無誤',
  mpMultiplayer: '多人同步',
  mpSync: '多人同步',
  mpCodePlaceholder: '房間碼',
  mpEnter6Digit: '請輸入4位房間碼',
  mpJoin: '加入',
  mpPointQr: '對準QR碼掃描',
  mpQrLoadFail: 'QR庫載入失敗',
  mpLinkCopied: '連結已複製！',
  mpCopyLink: '複製連結',
  mpShareLink: '分享',
  startSolo: '單人開始',
  mpJumbo: '多人',
  mpCreateRoom: '建立房間',
  mpWaitingPartner: '等待同伴加入',
  mpWaitingStart: '等待開始',
  mpRoomCode: '房間碼',
  mpCopied: '已複製',
  mpCopyCode: '複製房間碼',
  mpScanToJoin: '掃碼加入',
  mpGameInfo: '比賽資訊',
  mpCourse: '球場',
  mpMode: '模式',
  mpStake: '底注',
  mpRoom: '房間',
  mpPlayerAssignment: '球員分配',
  mpMine: '我的',
  mpPartner: '對方',
  mpUnclaimed: '未認領',
  mpConnected: '已連線',
  mpError: '連線錯誤',
  mpConnecting: '連線中...',
  mpStartGame: '開始比賽',
  mpWaitingCreator: '等待建立者開始比賽...',
  mpClaimTitle: '選擇你的球員',
  mpClaimDesc: '選擇你要負責輸入成績的球員',
  mpSelectOne: '請至少選擇一位球員',
  mpConfirmClaim: '確認認領',
  mpConfirmSubmit: '確認提交',
  mpWaiting: '等待對方...',
  mpConfirmFinish: '確認 & 完成',
  mpConfirmNext: '確認 & 下一洞',
  mpAdvancedStats: '進階統計模式',
  mpHolesLabel: '洞',
  hcpLabel: '差點',
  hideInfo: '收起說明',
  learnMore: '了解更多',
  close: '關閉',
  clearRecent: '清除',
  recentCourses: '最近球場',
  endGame: '終止',
  shareRoundReport: '分享回合報告',
  allDataCleared: '所有比賽數據將被清除',
  endGameConfirm: '確定要終止比賽嗎？\n未完成的洞將不計入成績',
  holeLabel: '{n}洞',
  holeLabelShort: '{n}洞',
  cameraAccessDenied: '無法存取相機',
  generateLinkFailed: '產生連結失敗',
  copyFailed: '複製失敗',
  retracted: '已撤回，可修改分數',
  matchPlayBubble: '每洞淨桿最低者贏。平手就沒有輸贏。',
  win123Bubble: '按淨桿排名。排名越低罰越重。UP可以贏更多，也可能輸更多。',
  skinsBubble: '每洞每人投注。只有單獨最低桿才贏走全部。平手就累積到下一洞。',
  baccaratBubble: '4人兩兩對戰，共6組對決。叫UP可以加注。',
  mpSyncBubble: '你記你的球員，朋友記他的，分數自動同步。不用再傳來傳去。',
  hcpBubble: '差點(0-36)：讓不同水平的球員公平競爭。系統根據球場難度自動分配讓桿到各洞。',
  undoEdit: '撤回修改',
  waitingProceed: '等待 {badge} 進入下一洞...',
  voiceWithHcp: '{player}，{on}上{putt}推，讓桿{handicap}。',
  voiceNoHcp: '{player}，{on}上{putt}推。',
  voiceHoleIntro: '第{hole}洞，標準桿{par}，難度指數{index}。',
  voiceHoleIntroNoIdx: '第{hole}洞，標準桿{par}。',
  voiceHcpOnHole: '{player}讓{strokes}桿',
  ttsLang: 'zh-TW',
  editLogTitle: '修改記錄',
  editLogHoleTitle: '第{n}洞 修改記錄',
  editLogEmpty: '沒有修改記錄',
  editLogCount: '{n} 條修改',
  editLogAllRecorded: '所有編輯操作均已記錄',
  editLogScore: '桿數',
  editLogPutts: '推桿',
  editLogUp: 'UP',
  editNotifyTitle: '第{n}洞 成績被修改',
  editNotifyBy: '由 {who} 編輯',
  editNotifyDetail: '點擊查看詳情',
  editLogTapHint: '點擊洞號上查看該洞修改記錄',
  editLogClose: '關閉',
  // Viewer Mode 觀戰模式
  mpRoleTitle: '加入房間',
  mpRoleDesc: '選擇加入方式',
  mpPlayerRole: '球員',
  mpPlayerRoleDesc: '認領球員並輸入桿數',
  mpPlayerTagInput: '輸入桿數',
  mpPlayerTagClaim: '認領球員',
  mpViewerRole: '觀戰',
  mpViewerRoleDesc: '即時觀看比賽，唯讀',
  mpViewerTagLive: '即時比分',
  mpViewerTagNoInput: '無法輸入',
  mpViewerBanner: '僅觀戰 — 無法輸入桿數',
  mpViewerReminder: '你正在觀看此比賽',
  mpViewerReminderDesc: '成績即時更新，你無法輸入或修改桿數。',
  exit: '退出',
  // Scorecard Section 記分卡
  scorecardHorizontal: '橫向',
  scorecardVertical: '縱向',
  shareBtn: '分享',
  penalties: '罰桿',
  // Feedback 意見回饋
  feedbackBtn: '意見回饋',
  feedbackTitle: '意見回饋',
  feedbackSubtitle: '幫助我們改進 HandinCap',
  feedbackRateLabel: '整體體驗評分',
  feedbackCatLabel: '您希望改進的方面（可多選）',
  feedbackCatNewModes: '增加比賽類型',
  feedbackCatUI: '介面優化',
  feedbackCatSpeed: '速度/效能',
  feedbackCatCourse: '球場資料',
  feedbackCatScoring: '計分功能',
  feedbackCatMultiplayer: '多人模式',
  feedbackCatBug: 'Bug 回報',
  feedbackCatOther: '其他建議',
  feedbackCommentPlaceholder: '請告訴我們您的想法...\n例如：希望增加 Nassau 玩法',
  feedbackSubmit: '提交回饋',
  feedbackSubmitting: '提交中...',
  feedbackThanks: '感謝您的回饋！',
  feedbackThanksDetail: '我們會認真閱讀每一條建議',
  feedbackSkip: '以後再說',
  feedbackStar1: '很差',
  feedbackStar2: '一般',
  feedbackStar3: '還行',
  feedbackStar4: '很好',
  feedbackStar5: '太棒了！',
  // 分享頁面
  shareInvalidLink: '無效連結',
  shareInvalidDesc: '此分享連結無效或已過期。',
  shareGoTo: '前往 HandinCap',
  poweredBy: '由',
  onLabel: '上果嶺',
  avg: '平均',
  totalLabel: '總計',
  // 多人模式補充
  mpConnectionStatus: '連線狀態',
  mpPlayersJoined: '已加入球員',
  mpViewersJoined: '已加入觀眾',
  mpNoPlayersYet: '還沒有球員加入。你仍可以開始——你將為所有球員記分。',
  mpProcessing: '處理中...',
  mpClaimed: '已認領',
  mpNoPlayers: '暫無可用球員',
  ob: 'OB',
  allConfirmed: '全部已確認',
  liveSyncing: '即時同步中',
  justNow: '剛剛',
  minsAgo: '{n}分鐘前',
  hrsAgo: '{n}小時前',
  roomNotFound: '房間未找到',
  // Round Report
  rrTitle: '回合報告',
  rrGolfCourse: '高爾夫球場',
  rrTotalScorePar: '總成績 (標準桿: {n})',
  rrShareImage: '分享圖片',
  rrShareLink: '分享連結',
  rrImageDownloaded: '圖片已下載',
  rrImageFailed: '產生圖片失敗',
  rrScreenshotFailed: '截圖失敗，請手動截圖',
  rrOpenApp: '開啟 HandinCap',
  loading: '載入中...',
};

export default zhTW;
